<template>
    <div class="carousel-sheet-container">
        <v-icon icon="mdi-medical-bag" size="200"  color="#3d5afe"/>
        <p>Medical results, recommendations etc. would be shown here (layout not final).</p>
    </div>
</template>

<script setup lang="js">

</script>

<style>


</style>